<template>
    <b-card class="dcx-kanban-item my-1" :class="cardCss" >
        <div class="container-fluid p-0" @click="openGridDefault()" style="cursor: pointer;">
            <div class="d-flex flex-row">
                <div class="float-left">
                    <img class="dcx-kanban-item-logo" :src="logoUrl" alt="Logo">
                </div>
                <div class="w-100">
                    <div class="dcx-kanban-item-title mb-1">
                        <slot></slot>
                    </div>
                    <div v-if="showDate" class="dcx-kanban-item-date">
                        due: {{ shortDate(dataCheck.nearestDueDate) }}
                    </div>
                    <div v-if="showName" class="dcx-kanban-item-name">
                        checked {{ dataCheck.timeSinceLastCheck }} by {{ dataCheck.recentUpdateBy }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showName">
            <span class="fa fa-2x fa-check text-success float-right"></span>
        </div>
        <div v-if="showStatusWeek">
            <div v-for="countryCheck in countryChecks" v-bind:key="countryCheck.id"
                 @click="openGrid(countryCheck.country_id, countryCheck.brand_id)"
                 style="cursor: pointer;"
            >
                <b-progress variant="success" :max="7" class="dcx-kanban-progress-info mt-2">
                    <b-progress-bar :value="getStatusWeek(countryCheck.due_in_days)">{{ countryCheck.country_id }}</b-progress-bar>
                </b-progress>
            </div>
        </div>
        <div v-if="showStatusNow" class="">
            <div v-for="countryCheck in countryChecks" v-bind:key="countryCheck.country_id"
                 @click="openGrid(countryCheck.country_id, countryCheck.brand_id)"
                 style="cursor: pointer;"
            >
                <b-progress :variant="getProgressNowVariant(countryCheck.overdue_by_days)"
                            :max="noOfDaysOnProgressScale"
                            class="dcx-kanban-progress-success mt-2"
                >
                    <b-progress-bar :value="getStatusNow(countryCheck.overdue_by_days)" style="white-space: nowrap">
                       <div class="pl-1">
                           {{ countryCheck.country_id }}
                           <span v-if="countryCheck.due_in_days > 1" class="fa fa-check"></span>
                       </div>
                    </b-progress-bar>
                </b-progress>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "KanbanItem",
    props: {
        dataCheck: {
            type: Object,
            required: true,
        },
        column: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            noOfDaysOnProgressScale: 7,
            isWellOverdue: false,
        }
    },
    computed: {
        showDate: function () {
            return this.column !== '4';
        },
        showName: function () {
            return this.column === '4';
        },
        showStatusWeek: function () {
            return this.column === '2';
        },
        showStatusNow: function () {
            return this.column === '3' && !this.showStatusLate;
        },
        showStatusLate: function () {
            return this.column === '3' && this.isWellOverdue;
        },
        statusNow: function () {
            return this.dataCheck;
        },
        cardCss: function () {
            let cssClass = 'dcx-kanban-item-queue';
            switch (this.column) {
                case '2':
                    cssClass = 'dcx-kanban-item-week';
                    break;
                case '3':
                    cssClass = 'dcx-kanban-item-now';
                    break;
                case '4':
                    cssClass = 'dcx-kanban-item-done';
                    break;
            }
            return cssClass;
        },
        logoUrl: function () {
            let id = String(this.dataCheck.id);
            return 'img/blg/' + id.padStart(3, '0') + '.png';
        },
        countryChecks: function () {
            return this.getCountryChecks();
        },
    },
    methods: {
        shortDate: function (dateIn) {
            let dateToConvert = new Date(dateIn);
            let dateSep = '-';
            let dateString =
                dateToConvert.getFullYear() + dateSep +
                ("0" + (dateToConvert.getMonth() + 1)).slice(-2) + dateSep +
                ("0" + dateToConvert.getDate()).slice(-2)
            ;
            return dateString;
        },
        getStatusWeek: function (daysUntilDue) {
            let days = daysUntilDue;
            if (days > this.noOfDaysOnProgressScale) {
                days = this.noOfDaysOnProgressScale;
            }
            return days;
        },
        getStatusNow: function (overdueDays) {
            let offset = 1;
            let days = overdueDays + offset;
            if (days > this.noOfDaysOnProgressScale) {
                days = this.noOfDaysOnProgressScale;
            }
            return days;
        },
        getProgressNowVariant: function (overdueDays) {
            let variant = 'success';
            if (overdueDays > this.noOfDaysOnProgressScale) {
                variant = 'danger';
            } else if (overdueDays > 0) {
                variant = 'warning';
            }
            return variant;
        },
        openGrid: function (countryId, brandId) {
            let url = '/grid-open?' + 'country=' + countryId + '&brand=' +brandId;
            let target = '_self';
            window.open(url, target);
            return false;
        },
        openGridDefault: function () {
            let dataCheck = this.dataCheck;
            if (!dataCheck) {
                return false;
            }
            let brandId = dataCheck['id'];
            let countryId = '';
            let mostUrgentDueDate = dataCheck['nearestDueDate'];
            Object.keys(dataCheck['dataChecks']).forEach((key, index3) => {
                let thisCheck = dataCheck['dataChecks'][key];
                if (thisCheck.next_check_due_date === mostUrgentDueDate) {
                    countryId = key;
                }
            });
            if (countryId && brandId) {
                this.openGrid(countryId, brandId);
                return true;
            }
            return false;
        },
        getCountryChecks: function () {
            let countries = [];
            let dataCheck = this.dataCheck;
            Object.keys(dataCheck['dataChecks']).forEach((countryId, index3) => {
                let thisCheck = dataCheck['dataChecks'][countryId];
                // console.log(thisCheck);
                let country = {
                    country_id: countryId,
                    brand_id: dataCheck['id'],
                    brand_name: dataCheck['name'],
                    due_in_days: thisCheck.due_in_days,
                    overdue_by_days: thisCheck.overdue_by_days,
                    date_checked: thisCheck.date_checked,
                    next_check_due_date: thisCheck.next_check_due_date,
                    user_id: thisCheck.user_id,
                    user_name: thisCheck.user_name,
                };
                countries.push(country);
            });
            return countries;
        }
    }
}
</script>

<style scoped>
.card-body {
    padding: 5px;
}
</style>
